<div [className]="collapse == true ? 'input-wrapper collapsed-side-form' : 'input-wrapper'">

  <div class="icon-collapse-condense" (click)="toggleCollapse()">
    <span
    class="tooltip-text fileupload-colapse">{{translationsService.translate('galis_js_file_upload_colapse')}}</span>
  </div>

  <div class="expand" (click)="toggleCollapse()">
    <div class="expand-icon"></div>
    <span
    class="tooltip-text fileupload-expand">{{translationsService.translate('galis_js_file_upload_expand')}}</span>
  </div>

  <div class="side-info-table">

    <!--div class="search-loader" *ngIf="showLoader">
    <img src="/assets/css/images/platform/loader.gif" />
  </div-->

  <sem-loader [showLoader]="showLoader"></sem-loader>



  <div class="side-wrapper edit-form-title-wrapper">
    <p class="input-form-title">{{translationsService.translate('WebGalis_LinkedDocuments')}}</p>
  </div>

  <table class="ld-table">
    @for (item of linkedDocuments; track item.Id) {
      <tr (click)="docSelected(item.Id,item.Url)">
        <td>
          <p>{{item.Title}}</p>
        </td>
        <!--td>
        <p>{{item.Type}}</p>
      </td-->
    </tr>
  }
</table>

</div>
</div>

@if (id>0 && url.length > 0) {
  <div class="split-s-form">
    <div class="split-header">
      <div class="breadcrumb">
        <div>
          <a>Povezani dokumenti</a>
        </div>
        <!--div>
        <span>|</span>
        <a class="form-title-breadcrumb">Knjiga vhodov</a>
      </div-->
    </div>
    <img class="close" src="../../../../assets/css/images/platform/uncheck-icon@3x.png" (click)="close()">
  </div>
  <div class="split-header split-sub-header">
        <a [href]="url+'?id='+id">
            <div class="s-liner">
                <div></div>
                <p>Odpri</p>
            </div>
        </a>
    </div>

    <ng-scrollbar>
        <div class="split-holder main-input-form">
            <div>

                <app-sem-dynamic-control [isSplitView]="true" [entityId]="id" [url]="url"></app-sem-dynamic-control>

            </div>
        </div>
    </ng-scrollbar>

</div>
}